<template>
  <div class="row justify-content-center">
    <div class="col-lg-12">
      <div
        class="bars-panel"
        :class="{ 'with-grey': minVal <= 0 }"
        :style="scaleBackground"
      >
        <template v-for="(item, n) in data">
          <div
            class="single-bars-item text-bar-big"
            :class="{ 'text-bar2': n > firstGeneral }"
            :style="{ left: `${styleLeft(item)}%` }"
            :key="n"
            v-if="item.name == $store.state.market.ticker"
          >
            <h5>{{ item.name }} {{ item.value | twoDigits }}</h5>
            <span
              class="bar-item-stick main"
              :style="{ background: color(styleLeft(item)) }"
            ></span>
          </div>
          <div
            class="single-bars-item text-bar"
            :class="{ 'text-bar2': n > firstGeneral }"
            :style="{ left: `${styleLeft(item)}%` }"
            :key="n"
            v-else-if="item.general"
          >
            <p>
              {{ item.name }} {{ item.value | twoDigits }}
              <span
                class="bar-item-stick general"
                :asdasd="color(styleLeft(item))"
                :style="{ background: color(styleLeft(item)) }"
              ></span>
            </p>
          </div>
          <div
            class="single-bars-item"
            :key="n"
            :style="{ left: `${styleLeft(item)}%` }"
            @mouseover="setStylePopover(n)"
            v-else
          >
            <p class="tooltip-trigger trigger-1">
              {{ item.name }}
              <span
                class="bar-item-stick normal"
                :style="{ background: color(styleLeft(item)) }"
              ></span>
            </p>
            <h6 style="text-align: center;">
              {{ item.value | twoDigits }}
            </h6>
            <div class="popover__content" :ref="`popover_${n}`">
              <p>
                {{ item.description }}
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

const MAXVAL = 15
const MINVAL = 0.001
// const minLeft = 0
const maxLeft = 100

export default {
  data() {
    return {}
  },
  methods: {
    setStylePopover(n) {
      try {
        const br = this.$refs[`popover_${n}`][0].getBoundingClientRect()
        const overlap = window.outerWidth - br.width - br.x
        if (overlap < 0)
          this.$refs[
            `popover_${n}`
          ][0].style.transform = `translateX(${(overlap / br.width) * 100 -
            53}%)`
      } catch (error) {
        console.error(`Can't set style for popover`, error)
      }
    },
    styleLeft(item) {
      const offset = 0 //this.minVal <= 0 ? 15 : 0
      return offset + (item.placeValue / MAXVAL) * (maxLeft - offset)
    },
    rgbToHex(r = 0, g = 0, b = 0) {
      const hex = function(x) {
        x = _.max([0, _.min([255, x])])
        x = x.toString(16)
        return x.length == 1 ? '0' + x : x
      }
      return '#' + hex(r) + hex(g) + hex(b)
    },
    color(percent) {
      if (percent < this.p1) return '#ccc'
      const [lr, lg, lb, rr, rg, rb, p1, p2] =
        percent < this.p2
          ? [51, 201, 111, 255, 190, 64, this.p1, this.p2]
          : [255, 190, 64, 255, 1, 0, this.p2, 100]
      // #ccc 0%, #ccc 14.9%, #33c96f 15%, #ffbe40 51.75%, #ff0100 100%

      const ratio = (percent - p1) / (p2 - p1)

      const [r, g, b] = [
        rr * ratio + lr * (1 - ratio),
        rg * ratio + lg * (1 - ratio),
        rb * ratio + lb * (1 - ratio),
      ].map(Math.ceil)

      return this.rgbToHex(r, g, b)
    },
  },
  computed: {
    p1() {
      let lastNegative = -1
      this.data.forEach((el, i) => {
        if (el.value < 0) lastNegative = i
      })

      return lastNegative === -1
        ? 0
        : ((lastNegative + 1.5) / (this.data.length + 1)) * 100
    },
    p2() {
      return (this.p1 + 100) / 2
    },
    // maxVal() {
    //   return _.max([
    //     MAXVAL,
    //     this.comparable.reduce((acc, el) => _.max([acc, el.value]), -200),
    //   ])
    // },
    minVal() {
      return _.min([
        MINVAL,
        this.comparable.reduce((acc, el) => _.min([acc, el.value]), +200),
      ])
    },
    firstGeneral() {
      let i = 0
      while (i < this.data.length) {
        if (this.data[i].general) return i
        i++
      }
      return 0
    },
    data() {
      let derivedData = _.cloneDeep(this.comparable)
      derivedData.sort((a, b) => a.value - b.value)
      const len = derivedData.length + 1
      derivedData = derivedData.map((el, i) => ({
        ...el,
        placeValue: MINVAL + ((MAXVAL - MINVAL) / len) * (i + 1),
      }))

      return derivedData
    },
    scaleBackground() {
      return {
        background: `linear-gradient(
            90deg,
            #ccc 0%,
            #ccc ${this.p1}%,
            #33c96f ${this.p1}%,
            #ffbe40 ${this.p2}%,
            #ff0100 100%
          )`,
      }
    },
  },
  filters: {
    twoDigits(val) {
      return Number(val).toFixed(2)
    },
  },
  props: {
    comparable: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.bar-item-stick {
  position: absolute;
  left: 50%;
  margin-left: -1px;

  &.normal {
    bottom: -3px;
    height: 6px;
    width: 2px;
  }

  &.main {
    top: 25px;
    height: 25px;
    width: 3px;
    left: 0;
  }

  &.general {
    top: 0;
    height: 15px;
    width: 2px;
  }
}
</style>
